"use client";

import { cn } from "@/lib/utils";

import { HeroSlideBackdrop } from "@/features/home/components/hero-slides/HeroSlideBackdrop";

import { MockupAccentStreaks } from "./MockupAccentStreaks";
import { mockupSizeClasses } from "./MockupScene.constants";
import type { MockupSceneProps } from "./MockupScene.types";

export const MockupScene = ({
  children,
  size = "bento",
  variant = "light",
  className,
}: MockupSceneProps) => {
  const isDark = variant === "dark";

  return (
    <div
      data-mockup-scene
      className={cn(
        "relative flex w-full flex-col overflow-hidden rounded-xl border shadow-[0_24px_64px_-28px_rgba(0,0,0,0.12)] dark:shadow-[0_24px_64px_-28px_rgba(0,0,0,0.85)]",
        mockupSizeClasses[size],
        isDark
          ? "border-white/[0.05] bg-[#0a0b0e]"
          : "border-zinc-200/50 bg-zinc-50 dark:border-white/[0.06] dark:bg-[#0c0d10]",
        className,
      )}
    >
      <HeroSlideBackdrop />
      <MockupAccentStreaks variant={variant} />
      <div className="relative flex h-full min-h-0 w-full flex-1">
        {children}
      </div>
    </div>
  );
};
